import RecordList from "../components/RecordList";

function VehiclesPage() {
  return <RecordList title="Vehicles" endpoint="/vehicles" columns={[["vehicleNo", "Vehicle no."], ["type", "Type"], ["make", "Make"], ["model", "Model"], ["assignedTo", "Assigned to"], ["status", "Status"], ["insuranceExpiry", "Insurance expiry"]]} />;
}

export default VehiclesPage;
